import React from 'react'

export function HelpScoutQuestionMarkIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="30"
      height="32"
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.25 12.0007C21.25 10.2325 20.5915 8.53685 19.4194 7.28661C18.2473 6.03636 16.6576 5.33398 15 5.33398C13.3424 5.33398 11.7527 6.03636 10.5806 7.28661C9.40848 8.53685 8.75 10.2325 8.75 12.0007C8.75 12.3543 8.8817 12.6934 9.11612 12.9435C9.35054 13.1935 9.66848 13.334 10 13.334C10.3315 13.334 10.6495 13.1935 10.8839 12.9435C11.1183 12.6934 11.25 12.3543 11.25 12.0007C11.25 11.2095 11.4699 10.4362 11.882 9.77837C12.294 9.12057 12.8797 8.60788 13.5649 8.30513C14.2502 8.00238 15.0042 7.92317 15.7316 8.07751C16.459 8.23185 17.1272 8.61281 17.6517 9.17222C18.1761 9.73163 18.5333 10.4444 18.6779 11.2203C18.8226 11.9962 18.7484 12.8005 18.4645 13.5314C18.1807 14.2623 17.7001 14.887 17.0834 15.3265C16.4667 15.7661 15.7417 16.0007 15 16.0007C14.6685 16.0007 14.3505 16.1411 14.1161 16.3912C13.8817 16.6412 13.75 16.9804 13.75 17.334V20.0007C13.75 20.3543 13.8817 20.6934 14.1161 20.9435C14.3505 21.1935 14.6685 21.334 15 21.334C15.3315 21.334 15.6495 21.1935 15.8839 20.9435C16.1183 20.6934 16.25 20.3543 16.25 20.0007V18.534C17.6617 18.2266 18.9305 17.4084 19.8416 16.2179C20.7528 15.0273 21.2503 13.5375 21.25 12.0007Z"
        fill="rgb(var(--background-secondary))"
      />
      <path
        d="M15 26.6667C15.6904 26.6667 16.25 26.0697 16.25 25.3333C16.25 24.597 15.6904 24 15 24C14.3096 24 13.75 24.597 13.75 25.3333C13.75 26.0697 14.3096 26.6667 15 26.6667Z"
        fill="rgb(var(--background-secondary))"
      />
    </svg>
  )
}
